import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { alpha, styled, Box } from '@mui/material';
import { format } from 'date-fns';
import enUS from 'date-fns/locale/en-US';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 5,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },

  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },

  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },

    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));

const TableItem = ({ data }) => {
  return (
    <TableRow className='item-hover'>
      <StyledTableCell>
        <Box className='textwrap1'>
          {data.merged_user_first_name}&nbsp;&nbsp;&nbsp;
          {data.merged_user_last_name}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='center'>
        <Box className='textwrap1'>
          {data.source_user_first_name}&nbsp;&nbsp;&nbsp;
          {data.source_user_last_name}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='center'>
        <Box className='textwrap1'>
          {data.target_user_first_name}&nbsp;&nbsp;&nbsp;
          {data.target_user_last_name}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='center'>
        {format(new Date(data.created_at), 'MMM dd, yyyy', {
          locale: enUS,
        })}
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;

TableItem.propTypes = {
  data: PropTypes.object.isRequired,
};
